<app-modal-header (closeModal)="close()">
  <h1 class="modal-title fs-5 pe-2">{{ detail?.term_public }}</h1>
</app-modal-header>
<app-modal-body>
  <div class="pb-3 pt-1 sticky-top position-sticky bg-color-event">
    <div class="position-relative">
      <input
        type="text"
        class="form-control rounded-4 pe-5"
        placeholder="{{ 'FIND_A_KEYWORD' | translate }}"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
      />
      @if (searchTerm) {
        <button
          type="button"
          class="btn position-absolute top-0 end-0 mt-0 me-3 p-0"
          (click)="onClearSearch()"
          aria-label="Clear search"
        >
          <i class="ri-close-line fs-4 opacity-50"></i>
        </button>
      }
    </div>
  </div>
  <ul class="list-group text-break">
    @for (item of localList; track $index; let i = $index) {
      @if (item.value.length === 0) {
        @if (item.title.trim().length > 0) {
          <li
            class="list-group-item d-flex justify-content-between align-items-center p-2"
            tabindex="0"
            role="button"
            (click)="selectFilter(detail?.term_id, item.title, '', detail?.term_public)"
          >
            {{ item.title }}
            @if (isSelected(detail?.term_id, item.title)) {
              <i class="ri-check-fill"></i>
            }
          </li>
        }
      }
    }

    <div ngbAccordion #accordion="ngbAccordion" [closeOthers]="true" [animation]="true">
      @for (item of localList; track $index; let i = $index) {
        @if (item.value.length > 0) {
          <div ngbAccordionItem="panel-{{ $index + 1 }}" [collapsed]="true">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton>
                @if (
                  (totalSelectedFilter | countInterestsSelected: { id: item.title_id!, termType: detail?.term_type }) >
                  0
                ) {
                  <span class="btn btn-sm btn-secondary rounded-3 d-inline me-1 fs-12px">
                    {{
                      totalSelectedFilter | countInterestsSelected: { id: item.title_id!, termType: detail?.term_type }
                    }}
                  </span>
                }
                {{ item.title }}
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="p-0">
                <ng-template>
                  @for (child of item.value; track $index; let j = $index) {
                    @if (child) {
                      <li
                        class="list-group-item d-flex justify-content-between align-items-center"
                        tabindex="0"
                        role="button"
                        (click)="selectFilter(item?.title_id, child, item.title, detail?.term_public)"
                      >
                        {{ child }}
                        @if (isSelected(item?.title_id, child)) {
                          <i class="ri-check-fill fs-5"></i>
                        }
                      </li>
                    }
                  }
                </ng-template>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </ul>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button class="btn btn-primary rounded-5 fw-medium" type="button" (click)="search()">
    {{ submitWord | translate }}
  </button>
  <button
    class="btn rounded-5 fw-medium"
    type="button"
    (click)="clear()"
    [class.btn-outline-dark]="!isBgDarkMode"
    [class.btn-outline-light]="isBgDarkMode"
  >
    {{ 'CLEAR' | translate }}
  </button>
</app-modal-footer>
